module.exports = __webpack_public_path__ + "static/img/guo.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guo.png
// module id = 4cRj
// module chunks = 9